<template>
    <div>
        <v-card class="pa-2">
            <canvas id="chart1" ref="chart1" height="508"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            amount: [],
            volume: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }

            console.log("chart1:", this.chartData);
            
            this.labels = this.chartData.map(e => e.date);
            this.amount = this.chartData.map(e => e.val);
            this.volume = this.chartData.map(e => e.vol);

            this.canvas = this.$refs['chart1'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Value',
                                      data: this.amount,
                                      borderColor: "rgb(33,150,243, 0.6)",
                                      borderWidth: 1,
                                      backgroundColor: "rgb(33,150,243, 0.3)",
                                      pointBackgroundColor: "rgb(33,150,243)",
                                      pointHoverBackgroundColor: "rgb(33,150,243)",
                                      pointRadius: 4,
                                      pointHoverRadius: 6 });
            chartData.datasets.push({ yAxisID: 2,
                                      data: this.volume,
                                      label: 'Volume',
                                      backgroundColor: "rgb(33,150,243, 0.3)",
                                      borderColor: "rgb(33,150,243, 1)",
                                      borderWidth: 1,
                                      fill: false,
                                      borderDash: [2],
                                      type: 'line' });

            this.chart = new Chart(this.canvas, {
                type: 'bar',
                data: {
                    labels: this.labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: 'Transactions By Day',
                        fontSize: 12,
                        fontStyle: 400,
                        // fontColor: '#FFF'
                    },
                    scales: {
                        yAxes: [{
                            positions: 'left',
                            ticks: {
                                id: 1,
                                maxTicksLimit: 10,
                                beginAtZero: true,
                                fontSize: 10,
                                // fontColor: '#FFF',
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'AED', minimumFractionDigits: 0 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12,
                                // fontColor: '#FFF'
                            },
                            gridLines: {
                                // zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                // color: "rgb(255, 255, 255, 0.2)"
                            }
                        },
                        {
                            id: 2,
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                // fontColor: '#FFF',
                                callback: function(value) {
                                    return value;
                                }
                            },
                            gridLines: {
                                display: false
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Volume',
                                fontSize: 12,
                                // fontColor: '#FFF'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                // fontColor: '#FFF'
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Day',
                                fontSize: 12,
                                // fontColor: '#FFF'
                            },
                            gridLines: {
                                // zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                // color: "rgb(255, 255, 255, 0.2)"
                            }
                        }]
                    },
                    legend: {
                        display: false,
                        labels: {
                            fontSize: 10,
                            // fontColor: '#FFF',
                            usePointStyle: true
                        },
                        position: 'bottom'
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltip) {
                                if(tooltip.datasetIndex != 1) {
                                    return `Value: ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'AED', minimumFractionDigits: 2 }).format(tooltip.value)}`;
                                }
                                else {
                                    return `Volume: ${tooltip.value}`;
                                }
                            }
                         }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>